import {Color} from '../model/Theme';

export class ColorUtils {
    static hexToRgb(hex: string): Color | null {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            red: parseInt(result[1], 16),
            green: parseInt(result[2], 16),
            blue: parseInt(result[3], 16),
            alpha: 1
        } : null;
    }

    static rgbToHex(color: Color): string {
        const componentToHex = (c: number) => {
            const hex = Math.round(c).toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        };
        return `#${componentToHex(color.red)}${componentToHex(color.green)}${componentToHex(color.blue)}`;
    }

    static colorToHex(color: Color): string {
        return this.rgbToHex(color);
    }
}
